<template>
  <div
    v-if="showLogo"
    id="InicioLogo"
    class="tooltip-container"
  >
    <!-- Imagen logo centrada con transición -->
    <transition
      name="fade"
      @before-leave="beforeLeaveLogo"
      @leave="leaveLogo"
    >
      <div v-if="showLogo" class="text-logo" @click="handleLogoClick">
        <img
          src="@/assets/1.png"
          alt="Logo"
          class="logo-img"
        />
      </div>
    </transition>

    <!-- Tooltip -->
    <span
      class="tooltip-text"
      :class="{ 'show-tooltip': showTooltip }"
    >{{ tooltipText }}</span>
  </div>
</template>

<script>
export default {
  name: 'InicioLogo',
  emits: ['logo-terminado'],
  data() {
    return {
      tooltipText: '¡Pulsa aquí!',
      showTooltip: false,
      showLogo: true,
      tooltipTimeout: null,
      transitioning: false,
    };
  },
  mounted() {
    this.tooltipTimeout = setTimeout(() => {
      this.showTooltip = true;
    }, 4000);
  },
  beforeUnmount() {
    if (this.tooltipTimeout) {
      clearTimeout(this.tooltipTimeout);
    }
  },
  methods: {
    handleLogoClick() {
      if (this.transitioning) return;
      this.showTooltip = false;
      this.startTransition();
    },
    startTransition() {
      this.transitioning = true;
      setTimeout(() => {
        this.showLogo = false;
        this.$emit('logo-terminado');
      }, 1000);
    },
    beforeLeaveLogo(el) {
      el.style.transition = 'opacity 1s ease-in-out';
    },
    leaveLogo(el) {
      el.style.opacity = 0;
    }
  }
};
</script>

<style scoped>
#InicioLogo {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;
  margin: 0;
  top:190px !important;
  border: none;
  overflow: hidden;
}

.text-logo {
  text-align: center;
  animation: scaleAnimation 1s ease-in-out infinite alternate both;
  cursor: pointer;
  z-index: 20;
}

.logo-img {
  width: 240px;
  height: auto;
  animation: pulse 2.5s ease-in-out infinite;
  transition: transform 0.3s ease-in-out;
}

.tooltip-text {
  visibility: hidden;
  width: 120px;
  background-color: rgba(0, 0, 0, 0.10);
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  position: absolute;
  top: calc(50% - 70px);
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  z-index: 30;
}

.show-tooltip {
  visibility: visible;
  opacity: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@keyframes scaleAnimation {
  0% {
    transform: scale(0.9);
    opacity: 0.8;
  }
  100% {
    transform: scale(1.2);
    opacity: 1;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.85;
  }
  50% {
    transform: scale(1.08);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.85;
  }
}
</style>
